import React from 'react'
import { observer } from 'mobx-react'
import constants from 'constants.js'
import Icon from 'components/common/Icon'
import { logout } from 'utils.js'
import { withTranslation } from 'react-i18next'

const UserPane = ({ user, t }) => (
  <div>
    <section>
      <label>
        <span>{t('GLOBAL.ACCOUNT')}</span>
      </label>
      <h2>{user.email}</h2>
    </section>
    <section>
      <a className='button' href={user.type === 'team_member' ? (constants.MY_ACCOUNT_URL + user.id) : constants.MY_PROFILE_URL}>
        <Icon id='fa-user-o' />
        <span>{t('GLOBAL.MY_PROFILE')}</span>
      </a>
      <button className='logout' onClick={logout}>
        <Icon id='fa-sign-out' />
        <span>{t('GLOBAL.LOG_OUT')}</span>
      </button>
    </section>
  </div>
)

export default withTranslation()(observer(UserPane))
